<div *ngIf="!selectionService.selection.selected.length" class="ddlLabel">No Documents Selected</div>
<div style="
  display: flex;
    flex-direction: row;
    align-items: baseline;
">
  <mat-form-field>
    <mat-label>--- Add Docs to Review Set ---</mat-label>
    <mat-select (selectionChange)="onReviewSetSelected($event)" #selectReviewSet [disabled]="!selectionService.selection.selected.length">
      <mat-option *ngFor="let reviewSet of available" [value]="reviewSet">{{reviewSet.name}}</mat-option>
    </mat-select>
  </mat-form-field>
  <button mat-icon-button color="primary" (click)="openAddReviewSetDialog()" matTooltip="Add New Review Set"><mat-icon>add</mat-icon></button>
